import { Heading } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { Route as CreditFacilitiesListRoute } from '~/core/routes/credit-facilities/_index';

export const BorrowerHomeRoute = () => {
  const flags = useFeatureFlags();
  if (flags.isBorrowerLimitedOrganization) {
    return <Navigate to="/funding-requests" />;
  }

  return (
    <>
      <Heading as="h2" mb="30px">
        Home
      </Heading>
      <CreditFacilitiesListRoute />
    </>
  );
};
